/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitterModel
 */
export interface SubmitterModel {
    /**
     * 
     * @type {string}
     * @memberof SubmitterModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitterModel
     */
    type?: SubmitterModelTypeEnum;
}


/**
 * @export
 */
export const SubmitterModelTypeEnum = {
    Unknown: 'UNKNOWN',
    Customer: 'CUSTOMER'
} as const;
export type SubmitterModelTypeEnum = typeof SubmitterModelTypeEnum[keyof typeof SubmitterModelTypeEnum];


/**
 * Check if a given object implements the SubmitterModel interface.
 */
export function instanceOfSubmitterModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmitterModelFromJSON(json: any): SubmitterModel {
    return SubmitterModelFromJSONTyped(json, false);
}

export function SubmitterModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitterModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function SubmitterModelToJSON(value?: SubmitterModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
    };
}

